import ScopeCheckContainer from './ScopeCheckContainer';
import { checkRequiredScopes } from './utils';

export default ScopeCheckContainer;
export { checkRequiredScopes };
